// extracted by mini-css-extract-plugin
export var backgroundContainmentImage = "HallFame-module--backgroundContainmentImage--282ae";
export var backgroundImage = "HallFame-module--backgroundImage--3f21c";
export var content = "HallFame-module--content--48097";
export var heading = "HallFame-module--heading--2b099";
export var image = "HallFame-module--image--cc666";
export var imageWrapper = "HallFame-module--imageWrapper--184a0";
export var name = "HallFame-module--name--1c5fa";
export var wrapper = "HallFame-module--wrapper--89d6b";